// Prix des abonnements — lus dans catalogue_tarifs (source unique, FCFA HT), lignes publiques
// seulement (policy catalogue_lecture_publique). Jamais de prix écrit dans le code.
import { useEffect, useState } from 'react';
import { supabase } from './supabase';

export const formatFcfa = (montant) => {
  const n = Number(montant);
  if (!Number.isFinite(n)) return '';
  return `${Math.round(n).toLocaleString('fr-FR')} FCFA`;
};

let cache = null;

/** { pro: { monthly, annual }, promax: { monthly, annual } } */
export async function chargerPrixPlans() {
  if (cache) return cache;
  const { data, error } = await supabase
    .from('catalogue_tarifs')
    .select('prix, details')
    .eq('categorie', 'plan');
  if (error) throw error;
  const plans = {};
  (data || []).forEach(({ prix, details }) => {
    const plan = details?.plan;
    const periode = details?.periode;
    if (!plan || !periode) return;
    plans[plan] = { ...(plans[plan] || {}), [periode]: Number(prix) };
  });
  cache = plans;
  return plans;
}

/** Prix des plans, ou null tant qu'ils ne sont pas chargés (ou s'ils sont illisibles). */
export function usePrixPlans() {
  const [prix, setPrix] = useState(cache);
  useEffect(() => {
    let actif = true;
    chargerPrixPlans().then((p) => { if (actif) setPrix(p); }).catch(() => {});
    return () => { actif = false; };
  }, []);
  return prix;
}
